import React from "react";

import SuccessFailSlideOutModal from "../components/SuccessFailSlideOutModal";

const Context = React.createContext();

export class SlideOutStatusProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSlideOutShown: false,
      message: null,
      title: null,
      successFailStatus: null,
      caseNumber: null,
      onClose: null,
    };
  }

  showStatusModal = (
    successFailStatus,
    message,
    title,
    caseNumber,
    onClose
  ) => {
    if (!this.state.isSlideOutShown)
      this.setState({
        isSlideOutShown: true,
        message,
        title,
        successFailStatus,
        caseNumber,
        onClose,
      });
  };

  hideStatusModal = () =>
    this.setState({ isSlideOutShown: false, successFailStatus: null });

  render() {
    const {
      state,
      showStatusModal,
      hideStatusModal,
      props: { children },
    } = this;

    return (
      <Context.Provider value={{ showStatusModal, hideStatusModal }}>
        {state.isSlideOutShown && (
          <SuccessFailSlideOutModal
            isFail={!state.successFailStatus}
            title={state.title}
            successMessage={state.message}
            failMessage={state.message}
            width="800"
            onClose={() => {
              state.onClose && state.onClose();
              hideStatusModal();
            }}
            caseNumber={state.caseNumber}
          />
        )}
        {children}
      </Context.Provider>
    );
  }
}

export const SlideOutStatusConsumer = Context.Consumer;
